import { Controller } from "@hotwired/stimulus"

// Contrôleur qui gère la relation entre le rôle et l'organisation
export default class extends Controller {
  static targets = ["role", "organizationField", "organizationSelect"]

  connect() {
    // Vérifier l'état initial au chargement de la page
    this.toggleOrganizationRequired()
  }

  // Appelé quand le rôle change
  roleChanged() {
    this.toggleOrganizationRequired()
  }

  // Fonction pour afficher/masquer et rendre requis le champ organisation
  toggleOrganizationRequired() {
    const isOsc = this.roleTarget.value === "osc"
    
    // Afficher ou masquer le champ d'organisation
    this.organizationFieldTarget.classList.toggle("hidden", !isOsc)
    
    // Rendre le champ requis ou non
    if (isOsc) {
      this.organizationSelectTarget.setAttribute("required", "required")
      this.organizationSelectTarget.setAttribute("aria-required", "true")
    } else {
      this.organizationSelectTarget.removeAttribute("required")
      this.organizationSelectTarget.removeAttribute("aria-required")
      // Vider la valeur du champ organisation si le rôle n'est pas OSC
      this.organizationSelectTarget.value = ""
    }
  }
} 